export const OPERATOR_TRACE_PALETTE = [
  "#031AA5",
  "#DB0C03",
  "#F5B002",
  "#F36924",
  "#69029B",
  "#F100F7",
  "#23A1C6",
  "#857012",
  "#740224",
  "#0F565C",
  "#040244",
  "#AE4E46",
  "#DF1B5F",
];

const listeners = new Set();

function storageKey(farmId) {
  return `dashboard-operator-trace-color-${farmId}`;
}

export function readOperatorTraceColors(farmId) {
  try {
    const raw = JSON.parse(
      window.localStorage.getItem(storageKey(farmId)) || "{}"
    );
    if (!raw || typeof raw !== "object" || Array.isArray(raw)) return {};
    return raw;
  } catch (error) {
    return {};
  }
}

function publish(farmId, colors) {
  try {
    window.localStorage.setItem(storageKey(farmId), JSON.stringify(colors));
  } catch (error) {
    // ignore
  }
  listeners.forEach((listener) => listener(colors, farmId));
}

export function subscribeOperatorTraceColors(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function nextFreeColor(used) {
  const free = OPERATOR_TRACE_PALETTE.find(
    (color) => !used.has(String(color).toUpperCase())
  );
  if (free) return free;
  return OPERATOR_TRACE_PALETTE[used.size % OPERATOR_TRACE_PALETTE.length];
}

/** Grava uma cor automática só para quem ainda não tem escolha. */
export function ensureOperatorTraceColors(farmId, operatorIds) {
  const colors = readOperatorTraceColors(farmId);
  const used = new Set(
    Object.values(colors).map((color) => String(color).toUpperCase())
  );
  let changed = false;

  (operatorIds || []).forEach((operatorId) => {
    if (operatorId == null || operatorId === "") return;
    const key = String(operatorId);
    if (colors[key]) return;
    const color = nextFreeColor(used);
    colors[key] = color;
    used.add(String(color).toUpperCase());
    changed = true;
  });

  if (changed) publish(farmId, colors);
  return colors;
}

export function setOperatorTraceColor(farmId, operatorId, color) {
  const colors = readOperatorTraceColors(farmId);
  colors[String(operatorId)] = color;
  publish(farmId, colors);
  return colors;
}
